import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { Button } from '@wordpress/components';
import { keyboardReturn } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import URLInput from '../url-input';
export default function LinkEditor(_ref) {
  let {
    autocompleteRef,
    className,
    onChangeInputValue,
    value,
    ...props
  } = _ref;
  return createElement("form", _extends({
    className: classnames('block-editor-url-popover__link-editor', className)
  }, props), createElement(URLInput, {
    value: value,
    onChange: onChangeInputValue,
    autocompleteRef: autocompleteRef
  }), createElement(Button, {
    icon: keyboardReturn,
    label: __('Apply'),
    type: "submit"
  }));
}
//# sourceMappingURL=link-editor.js.map